import store from "stores";
import { userType, userPrivilege } from "const/nuclias/user";
import { isNil, size } from "lodash";

const RULE = {
  SP: [userType.sp, userType.si, userType.org, userType.siteTag, userType.site],
  SI: [userType.si, userType.org, userType.siteTag, userType.site],
  ORG_MANAGER: [userType.org, userType.siteTag, userType.site],
  TAG_MANAGER: [userType.siteTag, userType.site],
  STORE_MANAGER: [userType.site],

  MANAGER: [userPrivilege.manager, userPrivilege.editor, userPrivilege.monitor, userPrivilege.viewer],
  EDITOR: [userPrivilege.editor, userPrivilege.monitor, userPrivilege.viewer],
  MONITOR: [userPrivilege.monitor, userPrivilege.viewer],
  VIEWER: [userPrivilege.viewer],
};

export const userPriv = (data) => { // == hideUnlessPrivilege: support userType, userPrivilege
  if (isNil(data) || size(data) < 1) {
    console.debug(`userPriv leak of key: ${data}`);
    return false;
  }
  const user = store.getState().user.user;
  if (RULE[user.privilege].indexOf(data) !== -1 || RULE[user.type].indexOf(data) !== -1) {
    return false;
  }
  return true;
};

export const userInvalid = (data) => { //
  if (isNil(data) || size(data) < 1) {
    console.debug(`userInvalid leak of key: ${data}`);
    return true;
  }
  const user = store.getState().user.user;
  if (data.indexOf(user.type) !== -1) {
    return true;
  }
  return false;
};


// export default {
//   userPriv,
//   userInvalid,
// }